// SVG builders ported from the prototype (returned as markup strings)
const rnd32 = (a) =>
  function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

const PINE =
  "M0,-200 L26,-140 L14,-140 L38,-84 L24,-84 L50,-30 L30,-30 L50,0 L-50,0 L-30,-30 L-50,-30 L-24,-84 L-38,-84 L-14,-140 L-26,-140 Z";

export function forest() {
  const rnd = rnd32(11);
  let g = "";
  const bands = [
    { y: 556, n: 30, h: 150, w: 56, c: "#3b6f66", b: 3, o: 0.55 },
    { y: 636, n: 24, h: 215, w: 74, c: "#2a5750", b: 2, o: 0.72 },
    { y: 726, n: 18, h: 285, w: 94, c: "#173f39", b: 1, o: 0.88 },
    { y: 812, n: 13, h: 360, w: 122, c: "#0d2a26", b: 0, o: 1 },
  ];
  for (const b of bands) {
    g += '<g style="filter:blur(' + b.b + 'px)" opacity="' + b.o + '">';
    for (let i = 0; i < b.n; i++) {
      const x = ((i + 0.5) / b.n) * 770 - 35 + rnd() * 26 - 13;
      const h = b.h * (0.75 + rnd() * 0.5),
        w = b.w * (0.8 + rnd() * 0.4);
      g +=
        '<path transform="translate(' +
        x.toFixed(1) +
        "," +
        b.y +
        ") scale(" +
        (w / 100).toFixed(2) +
        "," +
        (h / 200).toFixed(2) +
        ')" fill="' +
        b.c +
        '" d="' +
        PINE +
        '"/>';
    }
    g += "</g>";
  }
  return (
    '<svg viewBox="0 0 700 820" width="100%" height="100%" preserveAspectRatio="xMidYMax slice">' +
    '<defs><linearGradient id="sky" x1="0" y1="0" x2="0" y2="1">' +
    '<stop offset="0" stop-color="#ecc9b4"/><stop offset=".33" stop-color="#dabcb0"/>' +
    '<stop offset=".6" stop-color="#c2c8c3"/><stop offset="1" stop-color="#8fa9a4"/></linearGradient>' +
    '<radialGradient id="fog" cx=".5" cy=".6" r=".62"><stop offset="0" stop-color="#fff" stop-opacity=".5"/>' +
    '<stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient></defs>' +
    '<rect width="700" height="820" fill="url(#sky)"/>' +
    '<path d="M0,468 L118,428 L240,460 L360,418 L470,452 L590,412 L700,448 L700,566 L0,566 Z" fill="#7fa39c" opacity=".5" style="filter:blur(3px)"/>' +
    '<rect y="360" width="700" height="250" fill="url(#fog)"/>' +
    g +
    '<rect y="790" width="700" height="60" fill="#0d2a26"/></svg>'
  );
}

export function logo(scale) {
  const tri = (ox) =>
    '<g transform="translate(' +
    ox +
    ',0)"><path d="M0,44 L22,8 L44,44 Z" fill="none" stroke="#fff" stroke-width="2.4"/>' +
    '<g stroke="#fff" stroke-width="2.4">' +
    '<line x1="9.2" y1="24" x2="34.8" y2="24"/><line x1="6.3" y1="29" x2="37.7" y2="29"/>' +
    '<line x1="3.4" y1="34" x2="40.6" y2="34"/><line x1=".6" y1="39" x2="43.4" y2="39"/></g></g>';
  return (
    '<svg width="' +
    58 * scale +
    '" height="' +
    29 * scale +
    '" viewBox="0 0 78 48">' +
    tri(0) +
    tri(34) +
    "</svg>"
  );
}

export function logoRow(scale) {
  return (
    logo(scale) +
    '<div class="wm"><b>Summit</b><b>Ridge Bank</b><span>A Division of Ridge Credit Financial</span></div>'
  );
}

export function spark(sdata, w, h) {
  const min = Math.min.apply(null, sdata),
    max = Math.max.apply(null, sdata),
    rng = max - min || 1;
  const pts = sdata.map((v, i) => [(i / (sdata.length - 1)) * w, h - ((v - min) / rng) * (h - 10) - 5]);
  const d = pts.map((p, i) => (i ? "L" : "M") + p[0].toFixed(1) + " " + p[1].toFixed(1)).join(" ");
  return (
    '<svg viewBox="0 0 ' +
    w +
    " " +
    h +
    '" width="100%" height="' +
    h +
    '" preserveAspectRatio="none">' +
    '<defs><linearGradient id="sg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#a9d64b" stop-opacity=".32"/>' +
    '<stop offset="1" stop-color="#a9d64b" stop-opacity="0"/></linearGradient></defs>' +
    '<path d="' +
    d +
    " L" +
    w +
    " " +
    h +
    " L0 " +
    h +
    ' Z" fill="url(#sg)"/>' +
    '<path d="' +
    d +
    '" fill="none" stroke="#a9d64b" stroke-width="2"/></svg>'
  );
}
